import React, { useState, useEffect, useRef} from 'react';
import '../css/CompanyHouseDetails.css'
import { useSelector, useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Box,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Typography
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


import Button from '@mui/material/Button';
import {
  fetchCompanyDetails,
  setViewChouseDetails
} from '../slices/chouseSlice.js'
import logo from '../assets/logo.png'

import chtypes from '../helpers/chouseenumerated.js'
import parse from 'html-react-parser'

import CompanyHouseInfo from './CompanyHouseInfo'
import CompanyHouseFilings from './CompanyHouseFilings'
import CompanyHouseOfficers from './CompanyHouseOfficers'
import CompanyHouseInsolvency from './CompanyHouseInsolvency'


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  const isDataGridTab = index === 0;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simplech-tabpanel-${index}`}
      aria-labelledby={`simplech-tab-${index}`}
      style={
        isDataGridTab
          ? { display: value === index ? 'block' : 'none' } // Keep mounted
          : undefined // Default behavior for others
      }
      {...other}
    >
      {(!isDataGridTab || value === index) && (<Box sx={{ p: 3 }}>{children}</Box>)}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simplech-tab-${index}`,
    'aria-controls': `simplech-tabpanel-${index}`,
  };
}


function CompanyHouseDetails() {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(0)
  const [jsvisible,setjsVisible] = useState(false)
  const [openpdf, setOpenPdf] = useState(false)
  const [pdfhef, setPDFhref] = useState("")
  const isMobile = useMediaQuery('(max-width:768px)');

  const companyName = useSelector(state => state.chouse.companyName);
  const companyNumber = useSelector(state => state.chouse.companyNumber);
  const company = useSelector(state => state.chouse.company);
  const filings = useSelector(state => state.chouse.filings)
  const registered_office_address = useSelector(state => state.chouse.registered_office_address)
  const auth = useSelector(state => state.auth)
  const viewChouseDetails = useSelector(state => state.chouse.viewChouseDetails)
  const updatedat = useSelector(state => state.chouse.updatedat)
  const loaded = useSelector(state => state.chouse.loaded)

  const lead = useSelector(state => state.data.rowdata)

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue)
  };



  if(loaded)
    return (
  <>
    <Dialog
      open={viewChouseDetails}
      onClose={() => dispatch(setViewChouseDetails(false))}
      fullScreen
    >
      <DialogContent>
        <div className='header' >
          <div className='lefthead'>
            <h1>{companyName}</h1>
            <p className="company-number">
              Company number&nbsp;<span className='boldtext'>{companyNumber}</span><br/>
              Main Contact: {lead["FullName"]}<br/>
              <span className='updatedat'>Updated from Company House API at {new Date(updatedat??new Date()).toLocaleString()}</span><br/>
            </p>
          </div>
          <div className='righthead'>
            <img src={logo} style={{height: '50px', float: 'right'}} alt="TTP Logo" /><br/>
            <Button style={{display: 'block', marginLeft: '20px', float: 'right'}}  variant="outlined" onClick={()=> dispatch(setViewChouseDetails(false))}>&lt; Back to CRM</Button><br/>
           
          </div>
        </div>
        <Box sx={{ width: '100%', maxWidth: '1024px',  clear: 'both' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            {isMobile ? (
              <>
              <Select
                value={selectedTab}
                onChange={(e) => handleChange(e, e.target.value)}
                fullWidth
                size="small"
              >
                <MenuItem value={1}>Overview</MenuItem>
                <MenuItem value={2}>Filing History</MenuItem>
                <MenuItem value={3} >People</MenuItem>
                <MenuItem value={3} >Insolvency</MenuItem>
              </Select></>
            ) : (
              <Tabs 
                value={selectedTab} 
                onChange={handleChange} 
                aria-label="basic tabs example"
                sx = {{
                  "& button": {
                    borderTopLeftRadius: '4px',
                    borderTopRightRadius: '4px',
                    backgroundColor: 'white'
                  },
                  "& button.Mui-selected": {
                    borderLeft: '1px solid grey',
                    borderRight: '1px solid grey',
                    borderTop: '1px solid grey',
                    backgroundColor: 'white'
                  },
                  "& button:hover": {
                    borderLeft: '1px solid grey',
                    borderRight: '1px solid grey',
                    borderTop: '1px solid grey',
                    color: 'white',
                    backgroundColor: 'lightgrey'
                  }
            
                }}
              >
                <Tab label="Overview" {...a11yProps(0)}  />
                <Tab label="Filing History" {...a11yProps(1)} />
                <Tab label="People" {...a11yProps(2)}  />
                <Tab label="Insolvency" {...a11yProps(3)}  />
              </Tabs>
            )}
          </Box>
          <CustomTabPanel value={selectedTab} index={0}>
            {selectedTab === 0 && <CompanyHouseInfo /> }
          </CustomTabPanel>

          <CustomTabPanel value={selectedTab} index={1}>
            {selectedTab ==1 && <CompanyHouseFilings /> }
          </CustomTabPanel>

          <CustomTabPanel disabled value={selectedTab} index={2}>
            {selectedTab ==2 && <CompanyHouseOfficers /> }
          </CustomTabPanel>
          <CustomTabPanel disabled value={selectedTab} index={3}>
            {selectedTab ==3 && <CompanyHouseInsolvency /> }
          </CustomTabPanel>

        </Box>
      </DialogContent>
    </Dialog>
    </>
    )

}

export default CompanyHouseDetails